import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSelectMode = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.65905 6.05836L8.9398 19.4281C9.22281 20.3119 10.4526 20.367 10.8135 19.512L12.8984 14.5726C13.0092 14.3101 13.2267 14.1073 13.4963 14.0152L18.9994 12.1346C19.8709 11.8367 19.9105 10.6188 19.0601 10.265L5.99552 4.83014C5.20866 4.5028 4.39918 5.24673 4.65905 6.05836Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSelectMode;
